
const state = {
  test1: null,
  themeBar: false,
  uploading: false,
  progressmsg: 'File uploaded: ',
  percentageUploaded: 0,
  resetSplitButtonLocation: 0,
  errorsMessages: [],
  reLoginDialog: false,
  lastPage: '',
  lastFromPage: '',
  lastPathName: '',
  lastEPs: [],
  staticMenuDesktopInactive: null,
  activeThemeColor: 'blue', // stored as hex codes
  appWindowWidth: null,
  appWindowHeight: null,
  videosData: [],
  requestingVideos: false,
  lastErrorEP: null,
  epError: null,
  epPayload: null,
  errorCode: null,
  epDatetime: null
}

export default state